module.exports = __webpack_public_path__ + "img/Antoinelavoisier.76fdf672.jpg";